import React from "react";
import PropTypes from "prop-types";
import BankLogo from "./images/bank-logo.svg";
import styles from "./styles.css";
import { getPopupDetails } from "./selector";

const BankPopup = ({
    bankDetails,
    showSelfBought = false,
    isMismatchAccepted = false
}) => {
    const {
        account,
        verified: isBankVerified
    } = bankDetails || {};

    const {
        accountNumber = "",
        ifscCode = "",
        nameFromBank = ""
    } = account || {};

    const {title, image} = getPopupDetails(isBankVerified, showSelfBought, isMismatchAccepted);

    return (
        <React.Fragment>
            <h4>{title}</h4>
            <div styleName={"styles.bankWrapper"}>
                <div styleName={"styles.banklogo"}>
                    <div styleName={"styles.bankDetails"}>
                        <img src={BankLogo} />
                        <div styleName={"styles.bankAccountDetails"}>
                            <p>Account Number: </p>
                            {accountNumber && <h3> {accountNumber}</h3>}
                        </div>
                    </div>
                    <img src={image} />
                </div>

                {
                    (nameFromBank || ifscCode) &&
            <div styleName={"styles.accHolderName"}>
                {
                    nameFromBank &&
                    <p>Account Holder<br/>Name <span>{nameFromBank}</span></p>
                }
                {
                    ifscCode &&
                    <p>IFSC <span>{ifscCode}</span></p>
                }
            </div>
                }
            </div>
        </React.Fragment>
    );
};

BankPopup.propTypes = {
    bankDetails: PropTypes.object,
    showSelfBought: PropTypes.bool,
    isMismatchAccepted: PropTypes.bool
};

export default BankPopup;
